import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { fetchAllTeacherMeetings } from "../../../services/meeting";
import { TEACHER_ROLE } from "../../../constants";

export const fetchUserMeetings = createAsyncThunk(
  "course/fetchContent",
  async (user) => {
    try {
      const { status, data } = await fetchAllTeacherMeetings(
        user?.id,
        user?.role
      );
      if (status === 200) {
        let temp = data?.data?.map((item) => {
          return {
            ...item,
            user: user?.role === TEACHER_ROLE ? item?.student : item?.teacher,
          };
        });
        return temp;
      } else {
        toast.error(data?.message);
      }
    } catch (error) {}
  }
);
